// extracted by mini-css-extract-plugin
export var Bubble = "g_S";
export var styleBlue = "g_X";
export var styleGreen = "g_V";
export var styleOrange = "g_T";
export var styleRed = "g_W";